<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-31 11:46:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-08 10:03:35
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-26 09:54:45
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <el-button
          v-if="codeData.indexOf('413') != -1 || codeData.indexOf('414') != -1 || codeData.indexOf('415') != -1"
          @click="toAddManuscript"
          style="margin-right: 10px;"
          type="primary"
          >新增报备</el-button
        >
        <div  v-if="codeData.indexOf('418') != -1"  class="batch-operation">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">
               <a-menu-item   key="2"> 批量删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /> </a-button>
          </a-dropdown>
        </div>
      </div>
      <div class="right">
         <a-range-picker style="margin-right:12px;width:300px"  v-model="time" format="YYYY-MM-DD"/>
        <el-select
            clearable
            style="margin-left: 10px"
            v-model="applyStage"
            placeholder="阶段"
        >
          <el-option label="第一阶段" value="0"> </el-option>
          <el-option label="第二阶段" value="1"> </el-option>
          <el-option label="第三阶段" value="2"> </el-option>
        </el-select>
        <el-select
            clearable
            style="margin-left: 10px"
            v-model="applicationSource"
            placeholder="申请来源"
        >
          <el-option label="全部来源" :value="null"> </el-option>
          <el-option label="申请清单（线上）" value="0"> </el-option>
          <el-option label="申请报备（线下）" value="1"> </el-option>
        </el-select>
         <el-select
            clearable
            style="margin-left: 10px"
            v-model="administrativeReview"
            placeholder="行政复议"
          >
            <el-option label="行政复议全部" value=""> </el-option>
            <el-option label="行政复议未产生" value="0"> </el-option>
            <el-option label="行政复议已产生" value="1"> </el-option>
        </el-select>
         <el-select
            clearable
            style="margin-left: 10px;margin-right: 10px"
            v-model="administrativeProceeding"
            placeholder="行政诉讼"
          >
           
            <el-option label="行政诉讼全部" value=""> </el-option>
            <el-option label="行政诉讼未产生" value="0"> </el-option>
            <el-option label="行政诉讼已产生" value="1"> </el-option>
        </el-select>
        <el-button  @click="listSearch" type="primary" 
          >查询</el-button 
        >
      </div>
    </div>
    <coententTable
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      :isSelectRow="isSelectRow"
      @selectedRowKeys="selectedRowKeys"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
      :rowKeys="rowKeys"
    >
     <template v-slot:type="scopeVal">
        <span v-if="scopeVal.scope.type == 0">正常</span>
        <span style="color:#F56C6C" v-if="scopeVal.scope.type == 1">驳回</span>
     </template>
      <template v-slot:type="scopeVal">
        <span v-if="scopeVal.scope.type == 0">正常</span>
        <span style="color:#F56C6C" v-if="scopeVal.scope.type == 1">驳回</span>
     </template>
       <template v-slot:administrativeReview="scopeVal">
        {{scopeVal.scope.administrativeReview==0?'未产生':scopeVal.scope.administrativeReview==1?'已产生':'—'}}
     </template>
      <template v-slot:administrativeProceeding="scopeVal">
         {{scopeVal.scope.administrativeProceeding==0?'未产生':scopeVal.scope.administrativeProceeding==1?'已产生':'—'}}
     </template>
      <template v-slot:applyTime="scopeVal">
         {{scopeVal.scope.applyTime?scopeVal.scope.applyTime:'—'}}
     </template>
      <template v-slot:answerTime="scopeVal">
         {{scopeVal.scope.answerTime?scopeVal.scope.answerTime:'—'}}
     </template>
      <template v-slot:applyStage="scopeVal">
        <span v-if="scopeVal.scope.applyStage == 0">第一阶段</span>
        <span v-if="scopeVal.scope.applyStage == 1">第二阶段</span>
        <span v-if="scopeVal.scope.applyStage == 2">第三阶段</span>
     </template>
      <template v-slot:applicationSource="scopeVal">
        <span v-if="scopeVal.scope.applicationSource == 0">申请清单（线上）</span>
        <span v-if="scopeVal.scope.applicationSource == 1">申请报备（线下）</span>
      </template>
      <template v-slot:operation="scopeVal">
        <div style="display: flex">
           <div
            @click="editAdmin(scopeVal.scope)"
            class="btnTwo"
             v-if="codeData.indexOf('413') != -1 || codeData.indexOf('414') != -1 || codeData.indexOf('415') != -1"
            style="margin-right: 14px;"
          >
            编辑
          </div>
          <div
            @click="open(scopeVal.scope)"
            v-if="codeData.indexOf('417') != -1"
            class="btnThree"
          >
            删除
          </div>
        </div>
      </template>
    </coententTable>
    <el-dialog
      title="删除报备?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="quxiao"
      top="17%"
    >
      <span>该报备信息将完全被删除，若该报备信息存在实际的公开申请，请对该申请进行再次报备。</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="quxiao">取消</el-button>
        <el-button v-if="deleteNum == 'one'" size="medium" :loading="deleteShow" type="danger" @click="deleteOne()">确认删除</el-button>
        <el-button v-if="deleteNum == 'more'" size="medium" :loading="deleteShow" type="danger" @click="deleteTwo()">确认删除</el-button>
      </span>
    </el-dialog>
   
    <addRecord  :item="itemData"  @onClose="onClose" @close="close" :visible="visibleAdd"></addRecord>
  </div>
</template>

<script>
import {
  deleteApplyReportIds,
  deleteApplyReport,
  findListLogPage,
} from "../index";
import coententTable from "@/components/coentent_table.vue";
import { message } from "ant-design-vue";
import addRecord from './addRecord.vue'
export default {
  data() {
    return {
      visibleAdd:false,
      height: 0,
      time: [],
      deleteNum:'',
      columns: [
        {
          title: "申请人姓名",
          dataIndex: "name",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "220px",
                'max-width': "220px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "220px",
                'max-width': "220px",
              }
          };
        },
      },
        {
          title: "阶段",
          dataIndex: "applyStage",
          width: 120,
           scopedSlots: { customRender: "applyStage" },
        },
        {
          title:"受理机关",
          dataIndex: "disposeOffice",
          width: 150,
          scopedSlots: {customRender: "disposeOffice"},
        },
        {
          title:"申请来源",
          dataIndex: "applicationSource",
          width: 150,
          scopedSlots: {customRender: "applicationSource"}
        },
         {
          title: "状态",
          dataIndex: "type",
          width: 100,
          align:"center",
          scopedSlots: { customRender: "type" },
        },
         {
          title: "申请日期",
          dataIndex: "applyTime",
          width: 150,
          scopedSlots: { customRender: "applyTime" },
        },
         {
          title: "答复日期",
          dataIndex: "answerTime",
          width: 150,
          scopedSlots: { customRender: "answerTime" },
        },
         {
          title: "行政复议",
          dataIndex: "administrativeReview",
          scopedSlots: { customRender: "administrativeReview" },
          width: 120,
        },
        {
          title: "行政诉讼",
          dataIndex: "administrativeProceeding",
            scopedSlots: { customRender: "administrativeProceeding" },
          width: 120,
        },
         {
          title: "报备人",
          dataIndex: "stageName",
          width: 120,
        },
         {
          title: "报备时间",
          dataIndex: "creationTime",
          width: 200,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 180,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "type",
          customRender: "type",
        },
         {
          name: "applyStage",
          customRender: "applyStage",
        },
        {
          name:"applicationSource",
          customRender: "applicationSource"
        },
         {
          name: "administrativeReview",
          customRender: "administrativeReview",
        },
         {
          name: "administrativeProceeding",
          customRender: "administrativeProceeding",
        },
        {
          name: "applyTime",
          customRender: "applyTime",
        },
        {
          name: "answerTime",
          customRender: "answerTime",
        },
      ],
      rowKeys: [],
      dataType:'',
      loading: false,
      isSelectRow: true,
      loading: false,
      dialogVisibleTwo: false,
      codeData: [],
      dialogVisible:false,
      itemData:{},
      deleteShow:false,
      applyStage:'',
      applicationSource:"",
      administrativeReview:'',
      administrativeProceeding:'',
    };
  },
  components: {
    coententTable,
    addRecord,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    onClose(){
      this.visibleAdd = false;
      this.getList()
    },
    close(){
       this.visibleAdd = false;
    },
     farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
     handleMenuClick(e) {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return false;
      }
      this.dialogVisibleTwo = true;
      this.deleteNum = 'more';
      
    },
    toAddManuscript() {
       this.visibleAdd = true;
       this.itemData = {};
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    editAdmin(item) {
        this.itemData = item;
        this.visibleAdd = true;
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      findListLogPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        startTime,
        endTime,
        siteId:sessionStorage.getItem('siteId'),
        applyStage:this.applyStage,
        applicationSource:this.applicationSource,
        administrativeReview:this.administrativeReview,
        administrativeProceeding:this.administrativeProceeding,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.itemData = item;
      this.deleteNum = 'one';
    },
    quxiao(){
      this.dialogVisibleTwo = false;
    },
    deleteOne() {
      this.deleteShow = true;
      deleteApplyReport({
        id:this.itemData.id,
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.getList();
        }
      });
    },
     deleteTwo() {
      this.deleteShow = true;
      deleteApplyReportIds({
        idList:this.rowKeys,
      }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.rowKeys = [];
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
    .icon-st-doc-edit:before {
      color: #fff;
      margin-right: 5px;
      font-size: 16px;
    }
    .batch-operation {
      margin-right: 12px;
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.column-style {
  display: flex;
  cursor: pointer;
}
.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
.title-box {
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration:underline;
  cursor: pointer;
  color: rgba(24, 109, 230, 1);
  }
  /deep/ .ant-input-group{
    width: auto;
  }
</style>